/*
  SQINWEAR · Barra fija de talla ("barra de acciones") DESACTIVADA en todas las plantillas de producto.
  Motivo: estaba oculta pero activa y, junto a un código antiguo de la ficha, añadía productos al carrito solos.
  El elemento queda oculto e inerte: no escucha cambios, no se sincroniza y no puede enviar nada al carrito.
  Para recuperarla, restaurar el product-bar.js original del tema.
*/
class ProductBar extends HTMLElement {
  connectedCallback() {
    this.style.display = 'none';
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
    this.querySelectorAll('[name="add"], .product-bar__submit').forEach(function (b) {
      b.disabled = true;
      b.setAttribute('tabindex', '-1');
    });
  }
}

if (!customElements.get('product-bar')) {
  customElements.define('product-bar', ProductBar);
}
